import { IScope } from 'angular'
import { CustomerModalProps } from '@vend/business-components'
import { VdToastNotificationService } from '@vend/vend.ui'
import { ReactModalController } from '../../ReactModalController'

interface Options {
  customerId: string
  showEdit: boolean
}

/**
 * Controller class for the customer modal
 *
 * @class CustomerModalController
 */
export class CustomerModalController extends ReactModalController {
  public options: CustomerModalProps

  constructor(
    $scope: IScope,
    close: (val: Promise<any>) => void,
    vdEscapeStack: any,
    vdToastNotificationService: VdToastNotificationService,
    options: Options
  ) {
    'ngInject'
    super($scope, close, vdEscapeStack)

    this.options = {
      customerId: options.customerId,
      onClose: this.dismiss,
      onError: () => {
        this.dismiss()
        vdToastNotificationService.negative({
          message:
            'There was a problem loading the details for that customer. Please try again.',
        })
      },
      onIssueStoreCredit: () =>
        this.close(Promise.resolve({ action: 'issueStoreCredit' })),
    }

    if (options.showEdit) {
      this.options.onEdit = () =>
        this.close(Promise.resolve({ action: 'edit' }))
    }
  }
}
